"use client";
import {
  usePopoverHeading
} from "./RJDEYIKS.js";
import {
  createComponent,
  createElement,
  createHook
} from "./3ORBWXWF.js";

// src/hovercard/hovercard-heading.ts
var useHovercardHeading = createHook(
  (props) => {
    props = usePopoverHeading(props);
    return props;
  }
);
var HovercardHeading = createComponent(
  (props) => {
    const htmlProps = useHovercardHeading(props);
    return createElement("h1", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  HovercardHeading.displayName = "HovercardHeading";
}

export {
  useHovercardHeading,
  HovercardHeading
};
